<!--suppress ALL -->
<template>
  <div class="u-home clearfix">
    <div class="m-headlines">
      <img class="fl headlines-image" src="../../assets/images/home_left_icon.png" alt="头条">
      <div class="new-center-lin" style="overflow: hidden;">
        <!--"学党史 悟思想 办实事 开新局 —— 党史学习教育"-->
        <img src="../../assets/images/home_party_history2.jpg" style="width: 1020px;height: 90px;">
      </div>
    </div>
    <div class="wrap-left fl">
      <div class="swiper-meeting">
        <template>
          <el-carousel :interval="5000" arrow="always">
            <el-carousel-item
              v-for="{bannerNewsId, imageUrl, title} in infos.bigSwiperData"
              :key="bannerNewsId"
              class="swiper-big">
              <router-link
                :to="{ name: 'HomeDetails', query: { id: bannerNewsId }}"
                target="_blank">
                <img class="big-img" :src="imageUrl" alt="">
                <span class="title">{{ title }}</span>
              </router-link>
            </el-carousel-item>
          </el-carousel>
        </template>
      </div>
      <div class="news-work">
        <div class="more-line">
          <span
            class="fl table-title"
            :class="'has'"
            @click="changeHas(1)">
            工作动态
          </span>
          <router-link class="fr" :to="{name: 'WorkTrends'}">
            <span class="more-word fl">更多</span>
            <span class="more-button" />
          </router-link>
        </div>
        <news-list
          :list-number="8"
          :prop-list="infos.worksData" />
      </div>
      <div class="news-work">
        <div class="more-line">
          <span
            class="fl table-title has"
            @click="changeHas(1)">
            群团工作
          </span>
          <router-link class="fr" :to="{name: 'GroupMembers'}">
            <span class="more-word fl">更多</span>
            <span class="more-button" />
          </router-link>
        </div>
        <news-list
          :list-number="8"
          :prop-list="infos.grouData" />
      </div>
    </div>
    <div class="wrap-right fr">
      <div class="m-notice">
        <div class="notice-title">
          时政要闻
          <router-link class="fr" :to="{name: 'FocusNews'}">
            <span class="right-more-word fl">更多</span>
            <span class="right-more-button">...</span>
          </router-link>
        </div>
        <div class="motice-content">
          <news-list :prop-list="infos.newsData" />
        </div>
      </div>
      <div class="m-notice2">
        <div class="notice-title">
          支部动态
          <router-link class="fr" :to="{name: 'PartySpirit'}">
            <span class="right-more-word fl">更多</span>
            <span class="right-more-button">...</span>
          </router-link>
        </div>
        <div class="motice-content">
          <news-list :list-number="8" :prop-list="infos.groupActiveData" />
        </div>
      </div>
      <div class="m-notice2">
        <div class="notice-title">
          党内法规
          <router-link class="fr" :to="{name: 'PartyRules'}">
            <span class="right-more-word fl">更多</span>
            <span class="right-more-button">...</span>
          </router-link>
        </div>
        <div class="motice-content">
          <news-list :list-number="8" :prop-list="infos.rulesData" />
        </div>
      </div>
    </div>

    <div class="party-cool mt10">
      <div class="more-line">
        <span class="fl table-title has">党员风采</span>
        <router-link class="fr" :to="{name: 'PartyPresence'}">
          <span class="more-word fl">更多</span>
          <span class="more-button" />
        </router-link>
      </div>
      <div class="swiper-small" @mouseenter="sliderMouseenter" @mouseleave="sliderMouseleave">
        <div class="swiper-left" @click="left" />
        <div class="swiper-box">
          <ul class="small-slider-box">
            <li
              v-for="{id, headImageUrl, title} in infos.swiperSmall"
              :key="id"
              class="small-one-item"
              style="width: 186px;">
              <router-link :to="{ name: 'HomeDetails', query: { id: id }}" target="_blank">
                <img class="slider-image" :src="headImageUrl" alt="">
                <p class="slider-title">{{ title }}</p>
              </router-link>
            </li>
            <template v-for="(item,index) in infos.swiperSmall">
              <li
                v-if="index<6"
                :key="item.id+0.5"
                class="small-one-item"
                style="width: 186px;">
                <router-link :to="{ name: 'HomeDetails', query: { id: item.id }}" target="_blank">
                  <img class="slider-image" :src="item.headImageUrl" alt="">
                  <p class="slider-title">{{ item.title }}</p>
                </router-link>
              </li>
            </template>
          </ul>
        </div>
        <div class="swiper-right" @click="right" />
      </div>
    </div>
    <div class="party-cool link-firnd mt10">
      <div class="more-line">
        <span class="fl table-title has">友情链接</span>
      </div>
      <ul>
        <li>
          <a href="https://www.miit.gov.cn/ztzl/rdzt/qzjd100zn/index.html" target="_blank">工信部庆祝建党100周专题网站</a>
        </li>
        <li>
          <a href="https://www.miit.gov.cn/ztzl/rdzt/dsxxjyzl/index.html" target="_blank">工信部党史学习教育专题网站</a>
        </li>
        <li>
          <a href="http://www.12371.cn/dsxx/" target="_blank">党史学习教育官方网站</a>
        </li>
        <li>
          <a href="https://www.12371.cn/" target="_blank">共产党员网站</a>
        </li>
        <li>
          <a href="http://www.people.com.cn/" target="_blank">人民网</a>
        </li>
        <li>
          <a href="http://www.qstheory.cn/" target="_blank">求是网</a>
        </li>

      </ul>
    </div>
  </div>
</template>

<script>
import { getAllNews, getBanners } from '@/apis/user'

import NewsList from '@/components/newsList'

export default {
  components: {
    NewsList
  },
  data() {
    return {
      tableType: 1,
      slider: {
        smallSliderLen: -1, // 计数移动位置
        timer1: null, // 自动轮播
        timer2: null, // 一次移动
        bl: false, // 左边点击结束后纠正
        moveIntervalTime: 3000, // 滑动间隔时间
        moveTime: 500 // 一次滑动时间
      },
      infos: {
        headLineData: [], // 头条
        bigSwiperData: [], // 轮播
        worksData: [],
        grouData: [],
        newsData: [],
        groupActiveData: [],
        rulesData: [],
        swiperSmall: [],
        x: [],
        y: [],
        z: []
      }
    }
  },
  mounted() {
    this.sliderApi()
    this.getInfo()
  },
  methods: {
    jump(url) {
      window.open(url)
    },
    //  提取纯文本
    removeHTMLTag(str) {
      if (!str) return ''
      str = str.replace(/<\/?[^>]*>/g, '') // 去除HTML tag
      str = str.replace(/[ | ]*\n/g, '\n') // 去除行尾空白
      str = str.replace(/&nbsp;/ig, '')// 去掉&nbsp;
      str = str.replace(/\s/g, '') // 将空格去掉
      return str
    },
    async getInfo() {
      const {
        data:
          { newsList: [newsData, work, rule, cool, groupActiveData, groupMembers] }
      } = await getAllNews()

      // if (head.newsList.length) {
      //   this.infos.headLineData = head.newsList.map((item) => {
      //     item.content = item.content ? this.removeHTMLTag(item.content).substring(0, 30) : ''
      //     return item
      //   })
      //   // 两条轮播是不是轮询的，2变4（1不轮播 3正常）
      //   if (head.newsList.length === 2) {
      //     this.infos.headLineData = [...this.infos.headLineData, ...this.infos.headLineData]
      //   }
      // }
      const { data } = await getBanners()
      this.infos.bigSwiperData = data
      this.infos.worksData = work.newsList
      this.infos.grouData = groupMembers.newsList
      this.infos.newsData = newsData.newsList
      this.infos.groupActiveData = groupActiveData.newsList
      this.infos.rulesData = rule.newsList
      this.infos.swiperSmall = cool.newsList
    },
    changeHas(type) {
      this.tableType = type
    },
    /**
     * 轮播图
     * @param time1 多久轮播一个单位 ms
     * @param time2 轮播一个单位需要的时间 ms
     */
    sliderApi() {
      const $ul = document.getElementsByClassName('small-slider-box')[0]
      const $liLen = $ul.getElementsByTagName('li')
      this.slider.timer1 = setInterval(() => {
        this.slider.smallSliderLen += 1
        if ($liLen.length === this.slider.smallSliderLen + 6) {
          $ul.style.left = '0px'
          this.slider.smallSliderLen = 0
        }
        console.log(999)
        this.move($ul, 'right', this.slider.moveTime)
      }, this.slider.moveIntervalTime)
    },
    /**
     * 运动函数
     * @param $ul 需要移动的dom
     * @param direction 移动方向
     * @param time 移动所需时间
     */
    move($ul, direction, time) {
      clearInterval(this.slider.timer2)
      const startTime = new Date().getTime()
      const liWidth = parseInt($ul.firstChild.style.width, 10)
      const distance = direction === 'left' ? -liWidth : liWidth
      this.slider.timer2 = setInterval(() => {
        const nowTime = new Date().getTime()
        const needLeft = ((nowTime - startTime) / time) * distance // 时间比例就是距离比例
        if (Math.abs(needLeft) < Math.abs(distance)) {
          $ul.style.left = `${-needLeft + this.slider.smallSliderLen * -liWidth}px`
        } else {
          $ul.style.left = `${-distance + this.slider.smallSliderLen * -liWidth}px`
          if (direction === 'left') {
            this.slider.smallSliderLen -= 2
          }
          this.slider.bl = false
          clearInterval(this.slider.timer2)
        }
      }, 30)
    },
    left() {
      // 停止单次轮播
      clearInterval(this.slider.timer2)
      if (this.slider.bl) {
        this.slider.smallSliderLen -= 2
      }
      this.slider.bl = true
      const $ul = document.getElementsByClassName('small-slider-box')[0]
      const $liLen = $ul.getElementsByTagName('li')
      if (this.slider.smallSliderLen === -1) {
        this.slider.smallSliderLen = $liLen.length - 7
        $ul.style.left = 'parseInt($ul.firstChild.style.width, 10) * ($liLen.length - 6)px'
      }
      this.slider.smallSliderLen += 1
      this.move($ul, 'left', this.slider.moveTime)
    },
    right() {
      // 停止单次轮播
      clearInterval(this.slider.timer2)
      const $ul = document.getElementsByClassName('small-slider-box')[0]
      const $liLen = $ul.getElementsByTagName('li')
      this.slider.smallSliderLen += 1
      if ($liLen.length === this.slider.smallSliderLen + 6) {
        $ul.style.left = '0px'
        this.slider.smallSliderLen = 0
      }
      this.move($ul, 'right', this.slider.moveTime)
    },
    // 移入停止自动轮播，不结束开始的单次轮播
    sliderMouseenter() {
      clearInterval(this.slider.timer1)
      this.slider.timer1 = null
    },
    // 移开重新轮播
    sliderMouseleave() {
      if (!this.slider.timer1) {
        this.sliderApi()
      }
    }
  }

}
</script>

<style lang="scss" scoped>
  .u-home{
    width: 1200px;
    margin-top: 20px;
    margin-bottom: 22px;
    .m-headlines{
      width: 100%;
      height: 140px;
      border-top: 1px solid #9B181E;
      border-bottom: 1px solid #9B181E;
      .headlines-image{
        float: left;
        display: inline-block;
        width: 92px;
        height: 125px;
      }
      .new-center-lin{
        width: 1020px;
        height: 90px;
        background-color: #f8f8f8;
        margin-left: 110px;
        margin-top: 20px;
        line-height: 90px;
        text-align: center;
      }
      .new-center{
        width: 1020px;
        height: 90px;
        padding: 0 10px;
        background-color: #f8f8f8;
        margin-left: 110px;
        margin-top: 20px;
        line-height: 26px;
        .title{
          font-size:18px;
          text-align: center;
          padding: 8px 0;
        }
        .detail{
          margin-left: 10px;
          cursor: pointer;
          &:hover{
            color: #a61f24
          }
        }
        .el-carousel /deep/{
          height: 90px;
          .el-carousel__container{
            height: 90px;
          }
          .el-carousel__indicators{
            display: none;
          }
        }
      }
    }
  }
  .wrap-left {
    width: 745px;
    float: left;
    margin-left: 15px;
    height: auto;
    margin-top: 20px;
    .swiper-meeting{
      width:745px;
      height: 440px;
      .swiper-big{
        .title{
          position: absolute;
          bottom: 0;
          left: 0;
          width: 745px;
          height: 40px;
          line-height: 40px;
          background-color: rgba(40, 40, 40, 0.5);
          color: #fff;
          padding: 0 10px;
        }
        .big-img{
          width:745px;
          height:440px;
        }
      }
    }
    .news-work{

    }
    .service-people{
      ul{
        width: 100%;
        padding: 12px 10px;
        margin-top: 20px;
        margin-bottom: 10px;
        border: 1px solid #e5e5e5;
        overflow: hidden;
        li{
          float: left;
          width: 90px;
          height: 123px;
          padding: 12px 15px;
          cursor: pointer;
          .service-img{
            width: 60px;
            height: 60px;
            border-radius: 50%;
            border:solid 1px #9B181E;
            overflow: hidden;
            &:hover {
              background-color: #9B181E;
            }
            &:hover .hover-img{
              display: block;
            }
            &:hover .usual-img{
              display: none;
            }
            .hover-img, .usual-img{
              display: block;
              margin: 10px auto;
            }
            .hover-img{
              display: none;
            }
          }
          p{
            height: 14px;
            margin-top:19px;
            &:hover {
              color: #666;
            }
          }
        }
      }
    }
    .more-line{
      height: 46px;
      padding-top: 10px;
      border-bottom: 1px solid #9b181e;
      margin-bottom: 5px;
      .table-title{
        display: inline-block;
        width: 100px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 18px;
        color: #9b181e;
        font-weight: bold;
        cursor: pointer;
        &.has{
          color: #fff;
          background: url('../../assets/images/home_module_bg.png') no-repeat left bottom;
        }
      }
      .more-word{
        display: inline-block;
        height: 36px;
        line-height: 36px;
        color: #9b181e;
      }
      .more-button{
        display: inline-block;
        width: 24px;
        height: 36px;
        text-align: center;
        color: #fff;
        background: url('../../assets/images/home_more.png') no-repeat center center;
      }
    }
  }
  .wrap-right{
    width: 410px;
    float: right;
    margin-right: 15px;
    height: auto;
    margin-top: 20px;
    .m-notice,.m-notice2{
      width: 100%;
      border: solid 1px  #e5e5e5;
      margin-bottom:6px;
      .notice-title {
        height: 40px;
        line-height: 40px;
        font-size: 22px;
        font-weight: bold;
        background: #a61f24;
        padding-left: 10px;
        color: #fff;
        margin-left: -1px;
      }
      .motice-content{
        width: 390px;
        margin: 10px auto 27px;
      }
      .right-more-word{
        display: inline-block;
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        color: #ccc;
        font-weight: 400;
      }
      .right-more-button{
        float: right;
        margin-top: 10px;
        margin-left: 5px;
        margin-right: 2px;
        width: 18px;
        height:16px;
        text-align: center;
        line-height: 6px;
        font-size: 16px;
        font-weight: 400;
        color: #fff;
        font-weight: 600;
        background-color: #ccc;
        border-radius: 50% 48%;
      }
    }
    .m-notice2 /deep/{
      .motice-content{
        width: 390px;
        margin: 5px auto -1px;
        overflow: hidden;
        .news-line:last-child{
          border-bottom: none;
        }
      }
    }
  }
  .mt10 {
    margin-top:10px;
  }
  .el-carousel /deep/{
    height: 440px;
    .el-carousel__container{
      height: 440px;
    }
    .el-carousel__indicators--horizontal{
      bottom: 40px;
    }
  }
  .party-cool{
    float: left;
    height: 230px;
    margin-bottom: 20px;
    padding: 0 15px;

    .more-line{
      height: 46px;
      padding-top: 10px;
      border-bottom: 1px solid #9b181e;
      margin-bottom: 5px;
      .table-title{
        display: inline-block;
        width: 100px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 18px;
        color: #9b181e;
        font-weight: bold;
        cursor: pointer;
        &.has{
          color: #fff;
          background: url('../../assets/images/home_module_bg.png') no-repeat left bottom;
        }
      }
      .more-word{
        display: inline-block;
        height: 36px;
        line-height: 36px;
        color: #9b181e;
      }
      .more-button{
        display: inline-block;
        width: 24px;
        height: 36px;
        text-align: center;
        color: #fff;
        background: url('../../assets/images/home_more.png') no-repeat center center;
      }
    }
    .swiper-small{
      width: 100%;
      height: 172px;
      padding-top: 10px;
      .swiper-box{
        display: inline-block;
        width:1108px;
        height: 155px;
        overflow: hidden;
        .small-slider-box{
          position: relative;
          top: 0;
          left: 0;
          width: 100000px;
          height: 155px;
          cursor: pointer;
          .small-one-item{
            display: inline-block;
            float: left;
            width: 186px;
            height: 155px;
            padding-right: 15px;
            .slider-image{
              display: block;
              width: 168px;
              height: 116px;
            }
            .slider-title{
              height: 38px;
              line-height: 19px;
            }
          }
        }
      }
      .swiper-left{
        display: inline-block;
        width: 30px;
        height: 155px;
        background: url("../../assets/images/slider_left.png") no-repeat left center;
        cursor: pointer;
      }
      .swiper-right{
        display: inline-block;
        width: 30px;
        height: 155px;
        background: url("../../assets/images/slider_right.png") no-repeat right center;
        cursor: pointer;
      }
    }
  }
  .link-firnd{
    width: 1170px;
    height: 109px;
    ul{
      margin-top: 27px;
      li{
        float: left;
        padding: 0 12px;
        height: 16px;
        line-height: 16px;
        font-size: 16px;
        border-right: solid 1px #ccc;
        &:last-child{
          border: none;
        }
        &:hover{
          a{
            color: #9B181E
          }
        }
      }
    }
  }
</style>
